// extracted by mini-css-extract-plugin
module.exports = {"topNews":"topNews-1JFjerT4","first_title":"first_title-2B6clcrv","second_title":"second_title-1ebci0HE"};